/**
 * API client — promo extension Outlook
 */
import FamlaServices from './FamlaServices';

export type OutlookPromoTrigger = 'onboarding' | 'first_mapping' | 'first_interview';
export type OutlookPromoAction = 'shown' | 'dismiss' | 'cta';

export interface OutlookPromoState {
    onboarding_shown_at?: string | null;
    onboarding_dismissed_at?: string | null;
    onboarding_cta_at?: string | null;
    first_mapping_email_sent_at?: string | null;
    first_mapping_process_id?: string | null;
    first_mapping_shown_at?: string | null;
    first_mapping_dismissed_at?: string | null;
    first_interview_shown_at?: string | null;
    first_interview_dismissed_at?: string | null;
    first_interview_id?: string | null;
    global_dismissed_at?: string | null;
}

export interface OutlookPromoResponse {
    eligible: boolean;
    blocked_reason?: string | null;
    install_url: string;
    pending: OutlookPromoTrigger[];
    state: OutlookPromoState;
}

const emptyState = (): OutlookPromoResponse => ({
    eligible: false,
    blocked_reason: 'unavailable',
    install_url: 'https://appsource.microsoft.com/',
    pending: [],
    state: {},
});

export async function fetchOutlookPromo(accessToken: string): Promise<OutlookPromoResponse> {
    const response = await FamlaServices('api_host', '/outlook-promo/', 'GET', '', accessToken);
    if (response.status === 200 && response.body?.data) {
        return response.body.data as OutlookPromoResponse;
    }
    return emptyState();
}

export async function ackOutlookPromo(
    accessToken: string,
    trigger: OutlookPromoTrigger,
    action: OutlookPromoAction,
): Promise<OutlookPromoResponse> {
    const response = await FamlaServices(
        'api_host',
        '/outlook-promo/ack',
        'POST',
        { trigger, action },
        accessToken,
    );
    if (response.status === 200 && response.body?.data) {
        return response.body.data as OutlookPromoResponse;
    }
    return emptyState();
}

export async function optOutOutlookPromo(accessToken: string): Promise<OutlookPromoResponse> {
    const response = await FamlaServices('api_host', '/outlook-promo/opt-out', 'POST', {}, accessToken);
    if (response.status === 200 && response.body?.data) {
        return response.body.data as OutlookPromoResponse;
    }
    return emptyState();
}
